import { QUALIFICATION_VAL_LABEL_MAP } from 'apply-data';
import { DocAccessType, DocumentMap, IDocumentsList } from '../../../../types';
import { Section } from '../../../Finger/Section';
import FingerWithApprove from '../../../atoms/finger-with-approve';
import NoDocuments from '../../../atoms/no-doc-placeholder';
import { getFingerStatus, getVisible, hasDeleted } from '../../../../utilities/documents';
import { UserRole } from '../../../../store/auth/types';

interface IProps {
  infoOnly: boolean;
  userAccess?: DocAccessType;
  documents: DocumentMap;
  englishTestType?: string;
  qualification: string;
  qualificationOther?: string;
  warning?: string;
  userRole?: UserRole;
  canResume: boolean;
  canUpload: boolean;
  canOpen: boolean;
  canApprove: boolean;
  canReject: boolean;
  isDeleting: boolean;
  canAcknowledge: boolean;
  onResume: (url: string) => void;
  onUploadClick: (docKey: string) => void;
  onOpenClick: (docKey: string) => void;
  onApproveClick: (docKey: string) => void;
  onRejectClick: (docKey: string) => void;
  onRescindRejectClick: (docKey: string) => void;
  onDeleteClick: (docKey: string) => void;
  onAcknowledgeClick: (docKey: string) => void;
}

const EnglishQualification = (props: IProps) => {
  const englishQualification = props.documents ?? {};
  const { qualification, infoOnly, userAccess, qualificationOther, userRole } = props;
  let hasDocs = false;
  let hasDeletedDocs = false;
  const qualificationName =
    qualification && !qualificationOther ? QUALIFICATION_VAL_LABEL_MAP[qualification] : qualificationOther;
  const visibleDocs = getVisible({
    documentsHash: englishQualification,
    userAccess,
    infoOnly,
    userRole,
  }) as IDocumentsList[];
  if (visibleDocs.length > 0) {
    hasDocs = true;
  }
  if (hasDeleted(englishQualification)) {
    hasDeletedDocs = true;
  }
  const label = `${qualificationName} qualification used to meet English requirement`;

  if ((!hasDocs && !hasDeletedDocs) || !qualification) {
    return null;
  }

  if ((infoOnly || userAccess) && !hasDocs) {
    return null;
  }

  return (
    <Section
      label={label}
      canEdit={props.canResume}
      edit={() => {
        props.onResume('personal-info/step-6');
      }}
    >
      {visibleDocs.length > 0 ? (
        visibleDocs.map((englishQualification: IDocumentsList, index: number) => {
          const { key, item } = englishQualification;
          return (
            <FingerWithApprove
              key={`english-qualification-${index}`}
              status={getFingerStatus(item)}
              isProcessingPdf={item.isProcessingPdf}
              reason={item.reason}
              fileCount={item.signedUrls && item.signedUrls.length > 0 ? item.signedUrls.length : 0}
              fileNames={item.fileNames}
              label={`
                ${qualificationName} certificate or transcript ${
                  Object.keys(englishQualification).length > 1 ? (index > 0 ? index + 1 : '') : ''
                }`}
              canUpload={infoOnly ? false : props.canUpload}
              canOpen={infoOnly ? false : props.canOpen}
              canApprove={infoOnly ? false : props.canApprove}
              canReject={infoOnly ? false : props.canReject}
              isDeleting={infoOnly ? false : props.isDeleting}
              canAcknowledge={infoOnly ? props.canAcknowledge : false}
              onUploadClick={() => props.onUploadClick(key)}
              onOpenClick={() => props.onOpenClick(key)}
              onApproveClick={() => props.onApproveClick(key)}
              onRejectClick={() => props.onRejectClick(key)}
              onRescindRejectClick={() => props.onRescindRejectClick(key)}
              onDeleteClick={() => props.onDeleteClick(key)}
              onAcknowledgeClick={() => props.onAcknowledgeClick(key)}
              userRole={props.userRole}
              deletedByTTL={item.deletedByTTL}
            />
          );
        })
      ) : (
        <NoDocuments />
      )}
    </Section>
  );
};

export default EnglishQualification;
